<template>
  <div class="items-center gap-2">
    <div class="w-5 h-5">
      <img class="w-full h-full" src="@assets/images/US.svg" alt="US logo" />
    </div>
    <h6>En</h6>
    <div>
      <UiSingleSelect
        v-if="currentLanguage && currentLanguage.long"
        v-model="currentLanguage.long"
        class="uppercase"
        label="long"
        reduce="long"
        :hide-title="true"
        :options="[...baseLangs, {}]"
        placeholder="Select"
        :hide-un-select-icon="true"
        :border-update="true"
        selected-item-classes=""
        custom-text-size="lg:text-base text-sm lg:leading-[24px]"
        drop-down-container="right-1 w-full top-9 min-w-1"
        language-styling="capitalize font-semibold text-primary-gray-500"
        :icon-width="10"
        :icon-height="6"
        icon-color="primary-gray-500"
        @selectedObj="languageSelected"
      />
    </div>
  </div>
</template>

<script>
import UiSingleSelect from '@components/misc/UiSingleSelect.vue'
/* MIXINS IMPORT */
import languageMixin from '@src/mixins/theme-and-lang-mixins'
export default {
  components: {
    // Temporarily hide this component util we are not using language dropdown
    // UiSingleSelect,
  },
  mixins: [languageMixin],

  data() {
    return {
      currentLanguage: null,
    }
  },
  mounted() {
    if (localStorage.getItem('curLanguage')) {
      this.currentLanguage = JSON.parse(localStorage.getItem('curLanguage'))
      this.selectLang(this.currentLanguage)
    } else {
      this.currentLanguage = {
        id: 0,
        short: 'en',
        long: 'English',
        dir: 'ltr',
      }
      this.selectLang(this.currentLanguage)
      this.saveLanguageToLocalStorage(this.currentLanguage)
    }
  },
  methods: {
    languageSelected(lang) {
      this.currentLanguage = lang
      this.selectLang(lang)
      this.saveLanguageToLocalStorage(lang)
      this.$router.go()
    },
  },
}
</script>
